import Fetcher from '../../utility/Fetcher';
import Config from '../../utility/Config';

export function init(tag: any): void {
  tag.authenticate = () => {
    Fetcher.fetchAuthenticationData(Config.client, tag.username.value, tag.password.value);
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/loginForm/LoginFormController.ts
 **/